import { FC, Fragment } from "react";
// i18next
import { useTranslation } from "react-i18next";
// Hooks
import useMenu from "app/hooks/useMenu";
// MUI
import { Box, Tooltip } from "@mui/material";
// Icons
import { SettingsOutlined as SettingsOutlinedIcon } from '@mui/icons-material';
// Components
import { Checkbox, IconButton } from "app/components/Mui";
// Context
import { useInvoiceColumnsContext } from "./InvoiceColumns.context";

const InvoicesTableSettings:FC = () => {
  const { t } = useTranslation();

  const { Menu, openMenu } = useMenu();

  const { visibleColumns, toggleColumn, allColumns, visibleColumnsCount } = useInvoiceColumnsContext();

  return (
    <Fragment>
      <Tooltip title={t('labels.settings')}>
        <IconButton
          aria-label={t('labels.settings')}
          name="settings-invoices-table"
          size="small"
          onClick={openMenu}
        >
          <SettingsOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu>
        <Box sx={{ display: 'flex', flexDirection: 'column', px: 4 }}>
          {allColumns.map((column) => {
            const isChecked = visibleColumns.includes(column.id);
            return (
              <Checkbox
                key={column.id}
                name={column.id}
                label={t(column.labelKey)}
                value={isChecked}
                onChange={() => toggleColumn(column.id)}
                disabled={isChecked && visibleColumnsCount === 1}
              />
            )
          })}
        </Box>
      </Menu>
    </Fragment>
  )
}

export default InvoicesTableSettings;
